
























import {Component, Vue, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import ShardListTable from '@/components/lfs/NewShardList/ShardListTable.vue'
import SelectedShard from '@/components/lfs/NewShardList/SelectedShard.vue'
import Toolbar from '@/components/lfs/NewShardList/Toolbar.vue'
import Tooltip from '@/components/UI/Tooltip.vue';
import INotes from '@/components/icons/INotes.vue'
import ISurveyNew from '@/components/icons/ISurveyNew.vue'
import IFire from '@/components/icons/IFire.vue'


@Component({
  components: {
    ShardListTable,
    SelectedShard,
    Toolbar,
    Tooltip,
    'i-notes': INotes,
    'i-survey-new': ISurveyNew,
    'i-fire': IFire,
  }
})
export default class ArchiveShardList extends Vue {

    isSelectedShard:boolean = false
    shard:any = {title: "Иванов Иван", subtitle: "Стендист", dataSources: ["/img/newShards/0.png", "/img/newShards/1.png"], createdAtTimestamp: "1652217063", notes: "2", survey: "2/10", whoAdded: "Коля Петич", tag: "Новый", fire: 1, description: "менеджер федерального агенства государственной компаниии по продажа... из", city: "Kverneland", contacts: [{type: 0, value: "+79288888832", edit: false}, {type: 1, value: "admin@leadfrog.pro", edit: false}, {type: 2, value: "leadfrog.ru", edit: false}]}

    selectShard (shard:any) {
        this.shard = shard
        this.isSelectedShard = true
    }

    showTable() {
        this.isSelectedShard = false
    }
}
